import { render, staticRenderFns } from "./completarRegistro.vue?vue&type=template&id=747b16fe&scoped=true"
import script from "./completarRegistro.vue?vue&type=script&lang=js"
export * from "./completarRegistro.vue?vue&type=script&lang=js"
import style0 from "./completarRegistro.vue?vue&type=style&index=0&id=747b16fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747b16fe",
  null
  
)

export default component.exports